module.exports = "<span>\r\n    <span id=\"link-text\">Link to Scene #{{link.toSceneId}} - \"{{link.displayText}}\"</span>\r\n    <span class=\"align-right\">\r\n        <mat-icon id=\"edit-button\" class=\"interactive\" aria-label=\"Edit button\" (click)=\"editLink()\">edit</mat-icon>\r\n        <mat-icon id=\"delete-button\" class=\"interactive\" aria-label=\"Delete button\" (click)=\"deleteLink()\">delete</mat-icon>\r\n    </span>\r\n</span>"


//////////////////
// WEBPACK FOOTER
// C:/Repos/seeya/src/app/generator/link/link.component.html
// module id = ../../../../../src/app/generator/link/link.component.html
// module chunks = main